﻿import { ServiceOptions, serviceRequest } from "@serenity-is/corelib";
import { ActivateEmailTwoFactorRequest } from "./Extensions.ActivateEmailTwoFactorRequest";
import { ActivateEmailTwoFactorResponse } from "./Extensions.ActivateEmailTwoFactorResponse";
import { ActivateSMSTwoFactorRequest } from "./Extensions.ActivateSMSTwoFactorRequest";
import { ActivateSMSTwoFactorResponse } from "./Extensions.ActivateSMSTwoFactorResponse";
import { DeactivateEmailTwoFactorRequest } from "./Extensions.DeactivateEmailTwoFactorRequest";
import { DeactivateEmailTwoFactorResponse } from "./Extensions.DeactivateEmailTwoFactorResponse";
import { DeactivateSMSTwoFactorRequest } from "./Extensions.DeactivateSMSTwoFactorRequest";
import { DeactivateSMSTwoFactorResponse } from "./Extensions.DeactivateSMSTwoFactorResponse";
import { NotifyEmailTwoFactorRequest } from "./Extensions.NotifyEmailTwoFactorRequest";
import { NotifyEmailTwoFactorResponse } from "./Extensions.NotifyEmailTwoFactorResponse";
import { NotifySMSTwoFactorRequest } from "./Extensions.NotifySMSTwoFactorRequest";
import { NotifySMSTwoFactorResponse } from "./Extensions.NotifySMSTwoFactorResponse";
import { SetPreferredMethodTwoFactorRequest } from "./Extensions.SetPreferredMethodTwoFactorRequest";
import { SetPreferredMethodTwoFactorResponse } from "./Extensions.SetPreferredMethodTwoFactorResponse";

export namespace TwoFactorEndpointBaseService {
    export const baseUrl = '2FA';

    export declare function NotifyEmail(request: NotifyEmailTwoFactorRequest, onSuccess?: (response: NotifyEmailTwoFactorResponse) => void, opt?: ServiceOptions<any>): PromiseLike<NotifyEmailTwoFactorResponse>;
    export declare function ActivateEmail(request: ActivateEmailTwoFactorRequest, onSuccess?: (response: ActivateEmailTwoFactorResponse) => void, opt?: ServiceOptions<any>): PromiseLike<ActivateEmailTwoFactorResponse>;
    export declare function DeactivateEmail(request: DeactivateEmailTwoFactorRequest, onSuccess?: (response: DeactivateEmailTwoFactorResponse) => void, opt?: ServiceOptions<any>): PromiseLike<DeactivateEmailTwoFactorResponse>;
    export declare function NotifySMS(request: NotifySMSTwoFactorRequest, onSuccess?: (response: NotifySMSTwoFactorResponse) => void, opt?: ServiceOptions<any>): PromiseLike<NotifySMSTwoFactorResponse>;
    export declare function ActivateSMS(request: ActivateSMSTwoFactorRequest, onSuccess?: (response: ActivateSMSTwoFactorResponse) => void, opt?: ServiceOptions<any>): PromiseLike<ActivateSMSTwoFactorResponse>;
    export declare function DeactivateSMS(request: DeactivateSMSTwoFactorRequest, onSuccess?: (response: DeactivateSMSTwoFactorResponse) => void, opt?: ServiceOptions<any>): PromiseLike<DeactivateSMSTwoFactorResponse>;
    export declare function SetPreferredMethod(request: SetPreferredMethodTwoFactorRequest, onSuccess?: (response: SetPreferredMethodTwoFactorResponse) => void, opt?: ServiceOptions<any>): PromiseLike<SetPreferredMethodTwoFactorResponse>;

    export const Methods = {
        NotifyEmail: "2FA/NotifyEmail",
        ActivateEmail: "2FA/ActivateEmail",
        DeactivateEmail: "2FA/DeactivateEmail",
        NotifySMS: "2FA/NotifySMS",
        ActivateSMS: "2FA/ActivateSMS",
        DeactivateSMS: "2FA/DeactivateSMS",
        SetPreferredMethod: "2FA/SetPreferredMethod"
    } as const;

    [
        'NotifyEmail', 
        'ActivateEmail', 
        'DeactivateEmail', 
        'NotifySMS', 
        'ActivateSMS', 
        'DeactivateSMS', 
        'SetPreferredMethod'
    ].forEach(x => {
        (<any>TwoFactorEndpointBaseService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}